import { DbCustomerLotteryBetFiltersParams } from "./db-customer-lotery-bet-filters-params";
import { DbCustomerLotteryBetTasks } from "./db-customer-lotery-bet-tasks";
import { DbListBase } from "./db-list-base";
import { DbCustomerLotteryBetChecks } from "./db-customer-lotery-bet-checks";
import { DbObjectBase } from './db-object-base';
import { ICollectionReference, IDocumentReference } from '../database-cast/IDatabase';
import { Bet } from '../../../core/_shared/models/bet.model';
import { DbCustomerLotteryFiltersParams } from './db-customer-lotery-filters-params';


export class DbTaskCategoryStatus extends DbListBase<any> {

    constructor(collection: ICollectionReference) {
        super(collection);

    }
}


export class DbCustomerLotteryBets extends DbListBase<Bet> {

    public getBet(id: string): DbCustomerLotteryBet {

        let bet = new DbCustomerLotteryBet(id, this._collection);

        return bet;

    }

    constructor(collection: ICollectionReference) {
        super(collection);

    }
}


export class DbCustomerLotteryBet extends DbObjectBase<Bet> {


    // private _docReference: IDocumentReference;
    // _betId: string;

    constructor(betId: string, collection: ICollectionReference) {

        super(betId, collection);

        // this._docReference = collection.doc(betId);
        // this._betId = betId;
    }

    getFiltersParams() {
        let filters = new DbCustomerLotteryFiltersParams(this._docReference.collection("filter-params"));
        return filters;
    }

    public getTasks(): DbCustomerLotteryBetTasks {
        let tasks = new DbCustomerLotteryBetTasks(this._docReference.collection("tasks"));

        return tasks;
    }

    public getChecks(identifier: number): DbCustomerLotteryBetChecks {

        let tasks = new DbCustomerLotteryBetChecks(this._docReference.collection(`version/${identifier.toString()}/checks`));

        return tasks;
    }

    public getSimulations(identifier: number): DbCustomerLotteryBetChecks {

        let tasks = new DbCustomerLotteryBetChecks(this._docReference.collection(`version/${identifier.toString()}/simulations`));

        return tasks;
    }



    public getTotalChecks(identifier: number): DbCustomerLotteryBetChecks {


        let tasks = new DbCustomerLotteryBetChecks(this._docReference.collection(`version/${identifier.toString()}/total-checks`));

        return tasks;
    }

    public getTotalSimulations(identifier: number): DbCustomerLotteryBetChecks {


        let tasks = new DbCustomerLotteryBetChecks(this._docReference.collection(`version/${identifier.toString()}/total-simulations`));

        return tasks;
    }

    public getData(): Promise<Bet> {



        let promise: Promise<Bet> = new Promise((resolve) => {
            this._docReference.get()
                .then(snapshot => {
                    if (snapshot != null && snapshot.data()!=null) {
                        resolve(Object.assign(snapshot.data()));
                    }
                    else {
                        resolve(null);
                    }
                })
        });

        return promise;

    }


    public updateFields(bet: any): Promise<any> {



        let promise: Promise<Bet> = new Promise((resolve) => {
            this._docReference.setFields(Object.assign(bet))
                .then(result => {

                    resolve(bet);
                })

        });

        return promise;

    }

    public getDoc(): IDocumentReference {
        return this._docReference;
    }


}